
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse} from '@angular/Common/http';

import { ApiConfig } from '../../../core/api.service';


@Injectable()
export class ValidationService {

    constructor(private http: HttpClient) { }
    private apiConfigInstance = ApiConfig.getInstance();   

   

    // moved
    doesUserNameExist(accountName: string) {       
        var apiUrl = '/webapi/api/accountcreationtransitions/DoesUsernameExist/' + accountName + '/';
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }

    // moved
    doesEmailExist(email: string) {
        var apiUrl = '/webapi/api/accountcreationtransitions/DoesEmailExist/' + email + '/';
        return this.apiConfigInstance.getData(this.http, apiUrl);
    }
    
}
